// extracted by mini-css-extract-plugin
export var locationCard = "_da-0";